import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output
} from '@angular/core';
import {DropdownMenuComponent} from '../dropdown-menu';
import {DropdownMenuItem} from '../dropdown-menu/dropdown-menu-item';
import {ModalService} from '../modal';

const IS_DROPDOWN_OPEN_CLASS = '-is-open';

@Component({
    selector: 'button[dropdownMenuItems]',
    templateUrl: './dropdown-menu-button.component.html',
    styleUrls: ['./dropdown-menu-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownMenuButtonComponent {

    @Input()
    public dropdownMenuItems: DropdownMenuItem[];

    @Input()
    public isChevronShown: boolean;

    @Output()
    public onSelect: EventEmitter<any> = new EventEmitter<any>();

    @HostBinding(`class.${IS_DROPDOWN_OPEN_CLASS}`)
    public dropdownMenuComponent: DropdownMenuComponent;

    constructor(
        protected buttonElementRef: ElementRef,
        protected modalService: ModalService
    ) {}

    @HostListener('click', ['$event'])
    public setListeners(event: MouseEvent): boolean {
        event.stopPropagation();
        event.preventDefault();

        this.toggleDropdownMenu();

        return false;
    }

    protected toggleDropdownMenu(): void {
        if (!this.dropdownMenuComponent) {
            this.dropdownMenuComponent = this.modalService.open(DropdownMenuComponent, {
                configure: {
                    targetElement: this.buttonElementRef,
                    menuItems: this.dropdownMenuItems,
                    onCloseCallback: value => this.closeDropdownMenu(value)
                }
            }).instance;
        } else {
            this.closeDropdownMenu();
        }
    }

    protected closeDropdownMenu(value?: any): void {
        if (this.dropdownMenuComponent) {
            this.modalService.close(this.dropdownMenuComponent);
            this.dropdownMenuComponent = null;

            if (value !== undefined) {
                this.onSelect.emit(value);
            }
        }
    }

}
